module.exports = __webpack_public_path__ + "img/wu.6ffe50d8.png";